/** EDITABLE: free; LOCKED: a restricted value kept as is; READ_ONLY: agents disagree on a restricted value. */
export enum RankingAccess {
  EDITABLE = 'editable',
  LOCKED = 'locked',
  READ_ONLY = 'read_only',
}
